import { DAYS, computeRow, money, aggregate } from "../lib/calc";
import { FileDown, CheckCircle2, Landmark, Phone } from "lucide-react";

function AttCell({ value, onClick, testid }) {
  let style = "text-slate-300 hover:bg-slate-100", txt = "·";
  if (value === 1) { style = "bg-emerald-500 text-white hover:bg-emerald-600"; txt = "1"; }
  else if (value === 0.5) { style = "bg-amber-400 text-white hover:bg-amber-500"; txt = "½"; }
  else if (value === 0) { style = "bg-red-500 text-white hover:bg-red-600"; txt = "0"; }
  return (
    <td className="border border-slate-200 p-0">
      <button onClick={onClick} data-testid={testid}
        className={`w-full h-9 font-mono-data text-sm font-bold transition-colors ${style}`}>
        {txt}
      </button>
    </td>
  );
}

const numFmt = (n) => (Number(n) === Math.trunc(Number(n)) ? String(n) : Number(n).toFixed(1));

export default function PayrollTable({ entries, onAttendance, onLoanChange, onLoanCommit, onSobre, onToggleMark, onOpenLoans, onWorkerClick, onDownloadGroupSobres }) {
  const groups = {};
  entries.forEach((e) => {
    const k = e.project_name || "Sin obra";
    (groups[k] = groups[k] || []).push(e);
  });
  const grand = aggregate(entries);

  const numCols = 22;

  return (
    <div className="flex-1 overflow-auto border border-slate-200 bg-white scroll-fancy" id="print-area" data-testid="payroll-table">
      <table className="border-collapse text-sm min-w-max w-full">
        <thead className="sticky-th">
          <tr className="text-white">
            <th className="sticky-col bg-slate-800 border border-slate-700 p-2 text-left min-w-[180px]" rowSpan={2}>Trabajador</th>
            <th className="bg-slate-800 border border-slate-700 p-2 text-left" rowSpan={2}>Obra</th>
            <th className="bg-slate-700 border border-slate-600 p-2" colSpan={2}>Sueldo</th>
            <th className="bg-blue-700 border border-blue-600 p-2" colSpan={6}>Asistencia (1=Día · ½=Medio · 0=Falta)</th>
            <th className="bg-amber-700 border border-amber-600 p-2" colSpan={6}>Préstamos ($)</th>
            <th className="bg-slate-900 border border-slate-700 p-2" colSpan={6}>Totales</th>
          </tr>
          <tr className="text-white text-xs">
            <th className="bg-slate-700 border border-slate-600 p-1.5 min-w-[90px]">Semanal</th>
            <th className="bg-slate-700 border border-slate-600 p-1.5 min-w-[80px]">Diario</th>
            {DAYS.map((d, i) => <th key={"a" + i} className="bg-blue-600 border border-blue-500 p-1.5 w-10">{d.label}</th>)}
            {DAYS.map((d, i) => <th key={"p" + i} className="bg-amber-600 border border-amber-500 p-1.5 w-16">{d.label}</th>)}
            <th className="bg-slate-800 border border-slate-700 p-1.5">Asist.</th>
            <th className="bg-slate-800 border border-slate-700 p-1.5">Faltas</th>
            <th className="bg-slate-800 border border-slate-700 p-1.5 min-w-[90px]">Desc. Faltas</th>
            <th className="bg-slate-800 border border-slate-700 p-1.5 min-w-[90px]">Préstamos</th>
            <th className="bg-violet-700 border border-violet-600 p-1.5 min-w-[110px]">Abono Préstamo</th>
            <th className="bg-slate-800 border border-slate-700 p-1.5 min-w-[110px]">Total a Pagar</th>
          </tr>
        </thead>
        <tbody>
          {entries.length === 0 && (
            <tr><td colSpan={numCols} className="p-8 text-center text-slate-400">No hay registros para esta semana.</td></tr>
          )}
          {Object.entries(groups).map(([gname, rows]) => {
            const sub = aggregate(rows);
            return (
              <Group key={gname} gname={gname} rows={rows} sub={sub} numCols={numCols}
                onAttendance={onAttendance} onLoanChange={onLoanChange} onLoanCommit={onLoanCommit} onSobre={onSobre} onToggleMark={onToggleMark} onOpenLoans={onOpenLoans} onWorkerClick={onWorkerClick} onDownloadGroupSobres={onDownloadGroupSobres} />
            );
          })}
        </tbody>
        {entries.length > 0 && (
          <tfoot className="sticky bottom-0">
            <tr className="bg-slate-900 text-white font-mono-data font-semibold">
              <td className="sticky-col bg-slate-900 border border-slate-700 p-2 text-left font-heading" colSpan={2}>RESUMEN GENERAL</td>
              <td className="border border-slate-700 p-2" colSpan={2}></td>
              <td className="border border-slate-700 p-2 text-center" colSpan={6}>{numFmt(grand.asistencias)} / {numFmt(grand.faltas)}</td>
              <td className="border border-slate-700 p-2 text-right" colSpan={6}>{money(grand.totalPrestamos)}</td>
              <td className="border border-slate-700 p-2 text-center">{numFmt(grand.asistencias)}</td>
              <td className="border border-slate-700 p-2 text-center">{numFmt(grand.faltas)}</td>
              <td className="border border-slate-700 p-2 text-right">{money(grand.descuentoFaltas)}</td>
              <td className="border border-slate-700 p-2 text-right">{money(grand.totalPrestamos)}</td>
              <td className="border border-slate-700 p-2 text-right text-violet-300">{money(grand.abonoPrestamo)}</td>
              <td className="border border-slate-700 p-2 text-right text-emerald-300" data-testid="grand-total">{money(grand.totalPagar)}</td>
            </tr>
          </tfoot>
        )}
      </table>
    </div>
  );
}

function Group({ gname, rows, sub, numCols, onAttendance, onLoanChange, onLoanCommit, onSobre, onToggleMark, onOpenLoans, onWorkerClick, onDownloadGroupSobres }) {
  return (
    <>
      <tr className="bg-slate-100">
        <td className="sticky-col bg-slate-100 border border-slate-200 px-2 py-1.5" colSpan={numCols}>
          <div className="flex items-center justify-between">
            <span className="font-heading font-bold text-slate-700 text-xs uppercase tracking-wide">{gname} · {rows.length} trabajador(es)</span>
            <button onClick={() => onDownloadGroupSobres(rows[0]?.project_id || "none", gname)} data-testid={`group-sobres-${(rows[0]?.project_id || "none")}`}
              title="Descargar todos los sobres de esta obra (Word)"
              className="inline-flex items-center gap-1.5 text-[11px] font-semibold text-blue-700 hover:text-blue-900 bg-white border border-blue-200 rounded-sm px-2 py-1 transition-colors">
              <FileDown size={13} /> Sobres de la obra
            </button>
          </div>
        </td>
      </tr>
      {rows.map((e) => {
        const c = computeRow(e);
        return (
          <tr key={e.id} className={e.marcado ? "bg-emerald-100/70 hover:bg-emerald-100" : "hover:bg-blue-50/40"} data-testid={`entry-row-${e.id}`}>
            <td className={`sticky-col border border-slate-200 px-2 py-1.5 font-medium ${e.marcado ? "bg-emerald-300 border-l-4 border-l-emerald-700" : "bg-white"}`}>
              <div className="flex items-center gap-1.5">
                <button onClick={() => onToggleMark(e.id)} data-testid={`mark-${e.id}`} title="Marcar (aviso / ya realizado)"
                  className={`shrink-0 transition-colors ${e.marcado ? "text-emerald-800" : "text-slate-300 hover:text-emerald-600"}`}>
                  <CheckCircle2 size={15} />
                </button>
                <button onClick={() => onSobre(e.id, e.worker_name)} data-testid={`sobre-${e.id}`} title="Descargar sobre de nómina (Word)"
                  className="shrink-0 text-slate-400 hover:text-blue-600 transition-colors">
                  <FileDown size={15} />
                </button>
                <span onClick={() => onWorkerClick(e)} data-testid={`worker-click-${e.id}`} title="Editar trabajador (obra, sueldo, eliminar)"
                  className={`cursor-pointer hover:underline decoration-dotted ${e.marcado ? "text-emerald-950 font-bold" : "text-slate-800"}`}>{e.worker_name}</span>
                {(e.bank_name || e.bank_account) && (
                  <span title={`Datos bancarios: ${[e.bank_name, e.bank_account, e.bank_beneficiary && `Benef.: ${e.bank_beneficiary}`, e.phone && `Tel.: ${e.phone}`].filter(Boolean).join(" · ")}`} data-testid={`bank-badge-${e.id}`}
                    className="shrink-0 inline-flex items-center gap-0.5 rounded-sm bg-blue-600 text-white px-1 py-0.5 text-[10px] font-semibold leading-none">
                    <Landmark size={11} /> Banco
                  </span>
                )}
                {e.phone && (
                  <span title={`Teléfono: ${e.phone}`} data-testid={`phone-badge-${e.id}`}
                    className="shrink-0 inline-flex items-center gap-0.5 rounded-sm bg-emerald-600 text-white px-1 py-0.5 text-[10px] font-semibold leading-none">
                    <Phone size={11} /> Tel
                  </span>
                )}
              </div>
            </td>
            <td className="border border-slate-200 px-2 py-1.5 text-slate-500 text-xs">{e.project_name || "—"}</td>
            <td className="border border-slate-200 px-2 py-1.5 text-right font-mono-data">{money(c.weekly)}</td>
            <td className="border border-slate-200 px-2 py-1.5 text-right font-mono-data text-slate-500">{money(c.daily)}</td>
            {DAYS.map((d) => (
              <AttCell key={"a" + d.key} value={e.attendance?.[d.key]}
                onClick={() => onAttendance(e.id, d.key)} testid={`att-${e.id}-${d.key}`} />
            ))}
            {DAYS.map((d) => (
              <td key={"p" + d.key} className="border border-slate-200 p-0">
                <input type="number" min="0" value={e.loans?.[d.key] || ""}
                  onChange={(ev) => onLoanChange(e.id, d.key, ev.target.value)}
                  onBlur={() => onLoanCommit(e.id)} data-testid={`loan-${e.id}-${d.key}`}
                  className="w-full h-9 text-right px-2 font-mono-data text-sm bg-transparent focus:bg-amber-50 focus:outline-none focus:ring-1 focus:ring-amber-400" />
              </td>
            ))}
            <td className="border border-slate-200 px-2 py-1.5 text-center font-mono-data text-emerald-700">{numFmt(c.asistencias)}</td>
            <td className="border border-slate-200 px-2 py-1.5 text-center font-mono-data text-red-600">{numFmt(c.faltas)}</td>
            <td className="border border-slate-200 px-2 py-1.5 text-right font-mono-data text-red-600">{money(c.descuentoFaltas)}</td>
            <td className="border border-slate-200 px-2 py-1.5 text-right font-mono-data text-amber-700">{money(c.totalPrestamos)}</td>
            <td className="border border-slate-200 p-0">
              <button onClick={() => onOpenLoans(e)} data-testid={`abono-${e.id}`} title="Gestionar préstamos a plazos"
                className={`w-full h-9 px-2 flex items-center justify-end gap-1 font-mono-data hover:bg-violet-50 transition-colors ${c.abonoPrestamo > 0 ? "text-violet-700 font-semibold" : "text-slate-400"}`}>
                <Landmark size={13} className="opacity-70" />
                {money(c.abonoPrestamo)}
              </button>
            </td>
            <td className="border border-slate-200 px-2 py-1.5 text-right font-mono-data font-semibold text-slate-900" data-testid={`total-${e.id}`}>{money(c.totalPagar)}</td>
          </tr>
        );
      })}
      <tr className="bg-blue-50/60 font-mono-data text-xs">
        <td className="sticky-col bg-blue-50 border border-slate-200 px-2 py-1.5 text-right font-semibold text-slate-600" colSpan={2}>Subtotal {gname}</td>
        <td className="border border-slate-200" colSpan={14}></td>
        <td className="border border-slate-200 px-2 py-1.5 text-center text-emerald-700">{numFmt(sub.asistencias)}</td>
        <td className="border border-slate-200 px-2 py-1.5 text-center text-red-600">{numFmt(sub.faltas)}</td>
        <td className="border border-slate-200 px-2 py-1.5 text-right text-red-600">{money(sub.descuentoFaltas)}</td>
        <td className="border border-slate-200 px-2 py-1.5 text-right text-amber-700">{money(sub.totalPrestamos)}</td>
        <td className="border border-slate-200 px-2 py-1.5 text-right text-violet-700">{money(sub.abonoPrestamo)}</td>
        <td className="border border-slate-200 px-2 py-1.5 text-right font-semibold text-slate-900">{money(sub.totalPagar)}</td>
      </tr>
    </>
  );
}
